import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGrid = styled.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "faq5mq-0"
})(({
  $cssStyles,
  theme
}) => {
  return Object.assign({
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    marginInlineStart: `-${theme.space[400]}`,
    marginInlineEnd: `-${theme.space[400]}`
  }, $cssStyles);
});
export const Grid = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledGrid, Object.assign({
    $cssStyles: cssStyles
  }, domProps, callbackProps, {
    children: children
  }));
};